import { render, staticRenderFns } from "./TabsIcons.vue?vue&type=template&id=4ca37f5b&"
import script from "./TabsIcons.vue?vue&type=script&lang=js&"
export * from "./TabsIcons.vue?vue&type=script&lang=js&"
import style0 from "./TabsIcons.vue?vue&type=style&index=0&id=4ca37f5b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports